// jshint esversion: 6
import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import vuetify from "@/plugins/vuetify";
import store from "./store";
import * as globalComponents from "./globalComponents.js";
import Axios from "axios";
import Hammer from "hammerjs";
import AjaxHelper from "./js/AjaxHelper.js";
import Helper from "./js/Helper.js";
import BackButton from "./components/SimpleComponents/backButton.vue";
import { i18n } from "./plugins/i18n.js";
import FlagIcon from "vue-flag-icon";

const moment = require("moment");
require("moment/locale/de");

Vue.use(require("vue-moment"), {
  moment
});

Vue.use(FlagIcon);

import VuejsDialog from "vuejs-dialog";
import VuejsDialogMixin from "vuejs-dialog/dist/vuejs-dialog-mixin.min.js"; // only needed in custom components

// include the default style
import "vuejs-dialog/dist/vuejs-dialog.min.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog, {
  html: true,
  loader: false,
  okText: "OK",
  cancelText: "Cancel",
  animation: "bounce"
});

Axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    if (error.response != undefined && error.response.status != undefined && error.response.status == 401) {
      console.log("Axios 401");
      if (router.currentRoute.name != "Login") {
        console.log("Logging out..");
        store.dispatch("user/logout").then(() => {
          router.push("/Login");
        });
      }
    }

    if (error.response == undefined) {
      error.response = {
        status: "500"
      };
      error.response.data = "COBI.time Server cannot be reached!";
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

// Hide Productiontip:
Vue.config.productionTip = false;

/* HELPER */
window.AjaxHelper = AjaxHelper; // Delete this when not needed
window.Helper = Helper; // Delete this when not needed

// Globals

window.$ = require("jquery"); // Delete if not needed
Vue.prototype.$eventHub = new Vue(); // Global event bus for Notifications

if (process.env.VUE_APP_DEPLOYMENT === "KUBERNETES") {
  let url = window.location.origin;
  Vue.prototype.apiUrl = url;
} else {
  Vue.prototype.apiUrl = window.__env.api.url; // Global API Url for Backendserver
}
if (process.env.VUE_APP_VERSION == null) {
  const resolvedVersion = (typeof window !== "undefined" && window.VUE_APP_VERSION) || process.env.VUE_APP_VERSION || "2.0.0.0";
  Vue.prototype.$version = resolvedVersion;
} else {
  Vue.prototype.$version = process.env.VUE_APP_VERSION;
}

Vue.prototype.$moment.locale(i18n.locale);
Vue.prototype.$http = Axios; // Global HTTP Module
const token = localStorage.getItem("token"); // Login Token from Localstorage if exist
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = "Bearer " + token;
}

// Global Components

Vue.component("mybackbutton", BackButton);

Vue.directive("tap", {
  bind: function (el, binding) {
    if (typeof binding.value === "function") {
      const mc = new Hammer(el);
      mc.get("pan").set({
        direction: Hammer.DIRECTION_ALL,
        threshold: 80,
        pointers: 0
      });
      mc.on("panend tap", binding.value);
    }
  }
});

new Vue({
  el: "#app",
  i18n,
  router,
  vuetify,
  store,
  globalComponents,
  render: (h) => h(App)
}).$mount("#app");
